import { IRequestCommand } from '../../authentication/connection/iRequestCommand';
import { ErrorDetails } from '../../authentication/connection/interfaces/apiInterfaces';
import { CommandRequestType } from '../../authentication/connection/commandRequestType';
import { ICommandParameters } from '../../authentication/connection/iCommandParameters';
import { ICommandResponse } from '../../authentication/connection/iCommandResponse';

export class DeleteStripeVendorCommand extends IRequestCommand<
  ICommandResponse,
  ErrorDetails,
  IDeleteStripeVendorParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.DELETE;
  override _commandUrl = 'vendor/stripe/{userId}/{appId}';
  public override setParameters(parameters: IDeleteStripeVendorParameters) {
    this._commandUrl = this._commandUrl
      .replace('{userId}', parameters.userId.toString())
      .replace('{appId}', parameters.appId.toString());
  }
}

export interface IDeleteStripeVendorParameters extends ICommandParameters {
  userId: string;
  appId: number;
}
